import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import api from "../services/api";
var mobileotpresponse = {};
const MobileOtp = forwardRef(function MobileOtp(
  { name = "mobile", required = true, unique = false },
  ref
) {
  const [formInputData, setFormInputData] = useState({
    mobile: "",
    mobileVerified: false,
  });
  const [setLoaderActive, toast] = useContext(AppContext);
  //const [mobile, setMobile] = useState('9038647079');
  const [mobileOtp, setMobileOtp] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  //const [mobileVerified, setMobileVerified] = useState(false);
  const [otpCount, setOtpCount] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const handleMobile = async () => {
    if (formInputData.mobile && isMobileValid) {
      setLoaderActive(true);
      setMinutes(1);
      setSeconds(30);
      try {
        await api
          .get("/registration/send-otp-on-mobile/", {
            params: { key: formInputData.mobile, unique: unique },
          })
          .then((response) => {
            //console.log(data);
            const data = response.data;
            if (data.success) {
              mobileotpresponse = data.response;
              setMobileOtp(data.response.otp.otp);
              setOtpCount(otpCount + 1);
            } else {
              throw new Error(data.response);
            }
          });
      } catch (ex) {
        setMinutes(0);
        setSeconds(0);
        toast.error(ex.message);
      } finally {
        setLoaderActive(false);
      }
    } else {
      console.log("Invalid Mobile Number");
    }
  };

  const handleOtp = async () => {
    if (formInputData.mobile && isMobileValid) {
      if (!isNaN(mobileOtp) && mobileOtp.length === 6) {
        try {
          setLoaderActive(true);
          mobileotpresponse.otp.otp = mobileOtp;

          await api
            .post("/registration/verify-otp-on-mobile/", mobileotpresponse)
            .then((response) => {
              const data = response.data;
              if (data.success) {
                setFormInputData({ ...formInputData, mobileVerified: true });
              } else throw new Error("Otp Verification Failed");
            });
        } catch (ex) {
          setFormInputData({ ...formInputData, mobileVerified: false });
          toast.error(ex.message);
          console.log(ex);
        } finally {
          setMinutes(0);
          setSeconds(0);
          setLoaderActive(false);
        }
      }
    } else {
      console.log("Invalid Mobile Number");
    }
  };

  const resetMobile = (e) => {
    mobileotpresponse = {};
    setIsMobileValid(true);
    setOtpCount(0);
    setFormInputData({ ...formInputData, mobileVerified: false });
    setMobileOtp("");
    //timestampMobile = undefined;
  };
  const handleInputChange = (event) => {
    const inputFieldValue = event.target.value;
    const inputFieldName = event.target.name;
    if (isNaN(inputFieldValue) || inputFieldValue.length > 10) {
      return false;
    }
    const NewInputValue = {
      ...formInputData,
      mobile: inputFieldValue,
    };
    setFormInputData(NewInputValue);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useImperativeHandle(
    ref,
    () => {
      return {
        value: { ...formInputData },
      };
    },
    [formInputData]
  );

  return (
    <Form.Group className="mb-3">
      <InputGroup>
        <InputGroup.Text>+91</InputGroup.Text>
        <Form.Control
          placeholder="Mobile Number"
          aria-label="Mobile Number"
          required={required}
          type="tel"
          name={name}
          value={formInputData.mobile}
          onChange={handleInputChange}
          readOnly={formInputData.mobileVerified}
          pattern="[6-9][0-9]{9}"
        />
        <Button
          variant="outline-secondary"
          id="mobile-verify"
          onClick={handleMobile}
          disabled={formInputData.mobileVerified || seconds > 0 || minutes > 0}
        >
          {formInputData.mobileVerified ? (
            "Verified"
          ) : otpCount === 0 ? (
            "Send OTP"
          ) : seconds > 0 || minutes > 0 ? (
            <>
              {minutes < 10 ? `0${minutes}` : minutes}:
              {seconds < 10 ? `0${seconds}` : seconds}
            </>
          ) : (
            <>Resend OTP</>
          )}
        </Button>
        {!formInputData.mobileVerified && (
          <>
            <Form.Control
              placeholder="Mobile OTP"
              aria-label="Mobile OTP"
              value={mobileOtp}
              onChange={({ target }) => setMobileOtp(target.value)}
            />
            <Button variant="outline-secondary" onClick={handleOtp}>
              Verify
            </Button>
          </>
        )}
      </InputGroup>
      {formInputData.mobileVerified && (
        <>
          <Button variant="link" onClick={resetMobile}>
            Want to change mobile number?
          </Button>
        </>
      )}
    </Form.Group>
  );
});

export default MobileOtp;
